<div #scrollContainer class="over-scroll" (scroll)="onScroll($event)" [ngClass]="{'fixed-header' : fixedHeaderClass}">
<a [routerLink]="[]" fragment="main-content" class="skip-link" (click)="skipToContent()">Skip to main content</a>
<header angly-header></header>

<div class="angly-base-container">
  <div class="inner-container" id="main-content" tabindex="-1">
		<router-outlet (activate)="onActivate($event, scrollContainer)"></router-outlet>
  </div>
</div>
<!-- <footer angly-footer></footer> -->
<footer angly-footer2></footer>
</div>
